module.exports = __webpack_public_path__ + "img/ic_foot_hight_4.ab7437e5.png";